module.exports = __webpack_public_path__ + "img/vip.68f38e13.svg";